import React, { useState, useEffect } from "react";
import "./styles/profile.css";
import { useNavigate } from "react-router-dom";
import { Camera, LogOut, Medal, User } from "lucide-react";
import Footer from "../../../../components/footer";
import Navbar from "../../../../components/navbar";
import { useAuth } from "../../../../common/store/authStore";
import axios from "axios";
import { updateProfile } from "../../../../common/services/auth";
import Alert from "../../../../components/alert";
import { useAlert } from "../../../../hooks/useAlert";
import CustomAlert from "../../../../components/custom-alert";

function Profile() {
  useEffect(() => {
    document.title = "My Profile";
  }, []);

  const navigate = useNavigate();
  const { alert, showSuccess, showError, hideAlert } = useAlert();
  const { authenticatedUser, setAuthenticatedUser, clearAuth } = useAuth();
  const isLoggedIn = !!authenticatedUser;
  const [showLogoutAlert, setShowLogoutAlert] = useState(false);
  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  const defaultProfilePicture =
    "/images/casual-life-3d-profile-picture-of-man-in-green-shirt-and-orange-hat.png";
  const [uploading, setUploading] = useState(false);

  const handleProfilePictureChange = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.addEventListener("change", async (event) => {
      const selectedImage = (event.target as HTMLInputElement).files?.[0];
      if (selectedImage) {
        const reader = new FileReader();
        reader.onload = async () => {
          setUploading(true);
          try {
            const formData = new FormData();
            formData.append("file", selectedImage);
            formData.append("upload_preset", "ml_default");
            const response = await axios.post(
              "https://api.cloudinary.com/v1_1/dwp2kii1e/auto/upload",
              formData,
              { headers: { "Content-Type": "multipart/form-data" } },
            );
            const imageUrl = response.data.secure_url;

            const data = await updateProfile({ imageUrl });
            setAuthenticatedUser(data);
            showSuccess("Success" , "Profile picture updated successfully!");
            window.location.reload();
          } catch (error) {
            showError(
              "Failed to upload profile picture.",
              error.message,
            );
          } finally {
            setUploading(false);
          }
        }; 
        reader.readAsDataURL(selectedImage);
      }
    });
    input.click();
  };

  const handleLogout = () => {
    clearAuth();
    navigate("/login");
    setShowLogoutAlert(false);
  };

  return (
    <>
      <Navbar />
      <div className="profile-gamy-bg">
        <div className="profile-card-gamy">
          <div className="profile-avatar-gamy">
            <img
              src={authenticatedUser?.imageUrl || defaultProfilePicture}
              alt="Profile"
              className="profile-picture-gamy"
            />
            <button
              className="profile-edit-btn-gamy"
              onClick={handleProfilePictureChange}
              title="Change profile picture"
              disabled={uploading}
            >
              {uploading ? (
                <span className="profile-upload-spinner"></span>
              ) : (
                <Camera />
              )}
            </button>
          </div>
          <div className="profile-info-gamy">
            <h2 className="profile-name-gamy">
              <User style={{ marginRight: 8 }} />
              {authenticatedUser?.firstName} {authenticatedUser?.lastName}
            </h2>
            <p className="profile-email-gamy">{authenticatedUser?.email}</p>
            <div className="profile-badges-gamy">
              <span className="profile-badge-gamy">
                <Medal /> Rookie
              </span>
            </div>
          </div>
          <button className="profile-logout-btn-gamy" onClick={() => setShowLogoutAlert(true)}>
            <LogOut style={{ marginRight: 8 }} /> Logout
          </button>
        </div>
      </div>
      <Footer />
      <CustomAlert
        isOpen={showLogoutAlert}
        onClose={() => setShowLogoutAlert(false)}
        onConfirm={handleLogout}
        title="Logout"
        message="Are you sure you want to logout?"
        confirmText="Yes, logout"
        cancelText="Cancel"
        type="warning"
      />
      <Alert
        show={alert.show}
        type={alert.type}
        title={alert.title}
        message={alert.message}
        onClose={hideAlert}
        position="top-right"
        duration={4000}
      />
    </>
  );
}

export default Profile;
